import { QueryErrorBoundary } from "../../../../../../core/api/components/QueryErrorBoundary"
import React, { Suspense } from "react"
import { LoadingSpinner } from "../../../../../../shared/components/loading/LoadingSpinner"
import { GDPRContainer } from "./GDPRContainer"

export function GDPRListTab() {
    return (
        <QueryErrorBoundary>
            <Suspense fallback={<LoadingSpinner />}>
                <GDPRContainer />
            </Suspense>
        </QueryErrorBoundary>
    )
}
